import React from 'react'
import FiltrosAdicionadosManutencaoVeiculo from './FiltrosAdicionadosManutencaoVeiculo';
import Filtro from '../comum/Filtro'
import PainelFiltragem from '../comum/PainelFiltragem'
import CampoBuscaManutencaoVeiculo from './CampoBuscaManutencaoVeiculo';
import FiltroManutencaoVeiculo from './FiltroManutencaoVeiculo';

export const PainelFiltroManutencaoVeiculo = () => (
  <Filtro PainelFiltro={FiltroManutencaoVeiculo}/>
);

const PainelFiltrosManutencaoVeiculo = () => (
  <PainelFiltragem
    CampoBusca={CampoBuscaManutencaoVeiculo}
    Filtro={PainelFiltroManutencaoVeiculo}
    FiltrosAdicionados={FiltrosAdicionadosManutencaoVeiculo}/>
)

export default PainelFiltrosManutencaoVeiculo
